import { Tooltip } from 'ui_kit_qmd'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect, useState } from 'react'
import { isActiveEllipsisCheck } from '../../../utils/common'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const RemarksAuthor = ({ data: { FirstName, LastName, Prefix, Suffix, UserType }, index }) => {
  const [isAuthorNameEllipsisActive, setIsAuthorNameEllipsisActive] = useState(false)

  useEffect(() => {
    isActiveEllipsisCheck(`AuthorName-${FirstName}-${index}`, setIsAuthorNameEllipsisActive)
  }, [FirstName, index])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const getAuthor = (hasType) => {
    let author
    author = Prefix ? `${Prefix} ` : ''
    author += FirstName ? `${FirstName} ` : ''
    author += LastName ? `${LastName} ` : ''
    author += Suffix ? `${Suffix} ` : ''
    if (hasType) {
      author += UserType ? `(${UserType})` : ''
    }

    return author
  }

  return (
    <div className='remarks-author'>
      {/*
       // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered */}
      <Tooltip content={getAuthor()} disabled={!isAuthorNameEllipsisActive} maxWidth='420px'>
        <div id={`AuthorName-${FirstName}-${index}`} className='remarks-author-name'>
          {getAuthor(true)}
        </div>
      </Tooltip>
    </div>
  )
}
